import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Container,
  IconButton,
  Menu,
  MenuItem,
  Box,
  useTheme,
  useMediaQuery,
  alpha
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [

  ];

  return (
    <AppBar 
      position="static" 
      sx={{
        background: '#ffffff',
        boxShadow: '0 3px 5px 2px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              textDecoration: 'none',
              color: '#000000',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 700,
              letterSpacing: '0.5px',
              '&:hover': {
                textShadow: '0 0 8px rgba(0, 0, 0, 0.2)',
              }
            }}
          >
            <img 
              src="/Clever CV.svg"
              alt="Clever CV" 
              style={{ height: '98px', marginRight: '8px', fill: 'black' }}
            />
            CleverCV
          </Typography>

          {isMobile ? (
            <Box>
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
                sx={{
                  color: '#000000',
                  '&:hover': {
                    background: alpha('#000', 0.1),
                  }
                }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                  sx: {
                    background: '#ffffff',
                    color: '#000000',
                    boxShadow: '0 3px 5px 2px rgba(0, 0, 0, 0.1)',
                    '& .MuiMenuItem-root': {
                      '&:hover': {
                        background: alpha('#000', 0.1),
                      }
                    }
                  }
                }}
              >
                {menuItems.map((item) => (
                  <MenuItem 
                    key={item.text} 
                    onClick={handleClose} 
                    component={Link} 
                    to={item.path}
                    sx={{
                      padding: '10px 20px',
                      borderRadius: '4px',
                      margin: '4px 8px',
                    }}
                  >
                    {item.text}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {menuItems.slice(0, -1).map((item) => (
                <Button 
                  key={item.text}
                  sx={{
                    mx: 1,
                    color: '#000000',
                    position: 'relative',
                    '&:after': {
                      content: '""',
                      position: 'absolute',
                      width: '0',
                      height: '2px',
                      bottom: 0,
                      left: '50%',
                      background: '#000000',
                      transition: 'all 0.3s ease',
                      transform: 'translateX(-50%)',
                    },
                    '&:hover': {
                      background: 'transparent',
                      '&:after': {
                        width: '80%',
                      }
                    }
                  }}
                >
                  {item.text}
                </Button>
              ))}
              <Button
                variant="contained"
                component={Link}
                to="/contact"
                sx={{
                  ml: 2,
                  background: '#2196F3',
                  color: 'white',
                  fontWeight: 600,
                  '&:hover': {
                    background: '#1976D2',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Contact Us
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar; 